import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod/v4";

const recentReturnSchema_ = z.object({
  returnId: z.string(),
  orderName: z.string(),
  customerName: z.string().nullable(),
  totalAmount: z.number(),
  createdAt: z.date().nullable(),
  status: z.string(),
  productTitles: z.array(z.string()),
  grades: z.array(z.string()),
  itemCount: z.number(),
});
export const recentReturnSchema: z.ZodType<RecentReturn> = recentReturnSchema_;
export interface RecentReturn extends z.infer<typeof recentReturnSchema_> {}

const recentReturnsByGroupSchema_ = z.object({
  byStatus: z.record(z.string(), z.array(recentReturnSchema)),
  byGrade: z.record(z.string(), z.array(recentReturnSchema)),
});
export const recentReturnsByGroupSchema: z.ZodType<RecentReturnsByGroup> =
  recentReturnsByGroupSchema_;
export interface RecentReturnsByGroup
  extends z.infer<typeof recentReturnsByGroupSchema_> {}

export const getRecentReturns = unaryRpc({
  name: "getRecentReturns" as const,
  input: z.object({
    startDate: z.date(),
    endDate: z.date(),
    returnsCenterId: z.string().optional(),
    statuses: z.array(z.string()),
    grades: z.array(z.string()),
  }),
  output: recentReturnsByGroupSchema,
});
